export const RESTRICTED_INTEGRATION_NAMES = ["GUSTO"];
